import Util from "../helpers/util";

var UtilObject = new Util();

export default class admin_control {
  constructor() {
    var id = $(".Admin_Control_Id")[0].value;
    var side = $(".Admin_Control_Side")[0].value;

    if (side == "customer") {
      this.setCustomerDetails(id);
    } else {
      this.setVendorDetails(id);
    }
  }

  setCustomerDetails = async (customerID) => {
    //storing it in cookies - for JS
    UtilObject.createCookie("CUSTOMER_ID", customerID, 30);

    //Storing it in PHP
    await new Promise((resolve) => {
      $.ajax({
        url: baseURL + "api/customer/CustomerCookies/setSessionId",
        type: "POST",
        data: {
          data: {
            CUSTOMER_ID: customerID,
          },
        },
        success: (result) => {
          window.location.replace(baseURL + "customer/account");
          resolve();
        },
        error: (err) => {
          console.error(err);
          resolve();
        },
      });
    });
  };

  setVendorDetails = async (vendorID) => {
    //storing it in cookies - for JS
    UtilObject.createCookie("Vendor_ID", vendorID, 30);

    //Storing it in PHP
    await new Promise((resolve) => {
      $.ajax({
        url: baseURL + "api/customer/CustomerCookies/setSessionId",
        type: "POST",
        data: {
          data: {
            Vendor_ID: vendorID,
          },
        },
        success: (result) => {
          window.location.replace(baseURL + "Vendor_servicing_dashboard");
          resolve();
        },
        error: (err) => {
          console.error(err);
          resolve();
        },
      });
    });
  };
}

